import { Props } from "."

export const mockProps: Props = {}
